"use strict";
var BLEObject_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLEObject = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
const BufferUtils_1 = require("../utils/BufferUtils");
const BLEService_1 = require("./BLEService");
const BLEUUID_1 = require("./BLEUUID");
const MACAddress_1 = require("./MACAddress");
const RFTransmitterObject_1 = require("./RFTransmitterObject");
var AdvertisementType;
(function (AdvertisementType) {
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_FLAG"] = 1] = "BLE_AD_TYPE_FLAG";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_16SRV_PART"] = 2] = "BLE_AD_TYPE_16SRV_PART";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_16SRV_CMPL"] = 3] = "BLE_AD_TYPE_16SRV_CMPL";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_32SRV_PART"] = 4] = "BLE_AD_TYPE_32SRV_PART";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_32SRV_CMPL"] = 5] = "BLE_AD_TYPE_32SRV_CMPL";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_128SRV_PART"] = 6] = "BLE_AD_TYPE_128SRV_PART";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_128SRV_CMPL"] = 7] = "BLE_AD_TYPE_128SRV_CMPL";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_NAME_SHORT"] = 8] = "BLE_AD_TYPE_NAME_SHORT";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_NAME_CMPL"] = 9] = "BLE_AD_TYPE_NAME_CMPL";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_TX_PWR"] = 10] = "BLE_AD_TYPE_TX_PWR";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_DEV_CLASS"] = 13] = "BLE_AD_TYPE_DEV_CLASS";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_SM_TK"] = 16] = "BLE_AD_TYPE_SM_TK";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_SM_OOB_FLAG"] = 17] = "BLE_AD_TYPE_SM_OOB_FLAG";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_INT_RANGE"] = 18] = "BLE_AD_TYPE_INT_RANGE";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_SOL_SRV_UUID"] = 20] = "BLE_AD_TYPE_SOL_SRV_UUID";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_128SOL_SRV_UUID"] = 21] = "BLE_AD_TYPE_128SOL_SRV_UUID";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_SERVICE_DATA"] = 22] = "BLE_AD_TYPE_SERVICE_DATA";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_PUBLIC_TARGET"] = 23] = "BLE_AD_TYPE_PUBLIC_TARGET";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_RANDOM_TARGET"] = 24] = "BLE_AD_TYPE_RANDOM_TARGET";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_APPEARANCE"] = 25] = "BLE_AD_TYPE_APPEARANCE";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_ADV_INT"] = 26] = "BLE_AD_TYPE_ADV_INT";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_LE_DEV_ADDR"] = 27] = "BLE_AD_TYPE_LE_DEV_ADDR";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_LE_ROLE"] = 28] = "BLE_AD_TYPE_LE_ROLE";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_SPAIR_C256"] = 29] = "BLE_AD_TYPE_SPAIR_C256";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_SPAIR_R256"] = 30] = "BLE_AD_TYPE_SPAIR_R256";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_32SOL_SRV_UUID"] = 31] = "BLE_AD_TYPE_32SOL_SRV_UUID";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_32SERVICE_DATA"] = 32] = "BLE_AD_TYPE_32SERVICE_DATA";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_128SERVICE_DATA"] = 33] = "BLE_AD_TYPE_128SERVICE_DATA";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_LE_SECURE_CONFIRM"] = 34] = "BLE_AD_TYPE_LE_SECURE_CONFIRM";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_LE_SECURE_RANDOM"] = 35] = "BLE_AD_TYPE_LE_SECURE_RANDOM";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_URI"] = 36] = "BLE_AD_TYPE_URI";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_INDOOR_POSITION"] = 37] = "BLE_AD_TYPE_INDOOR_POSITION";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_TRANS_DISC_DATA"] = 38] = "BLE_AD_TYPE_TRANS_DISC_DATA";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_LE_SUPPORT_FEATURE"] = 39] = "BLE_AD_TYPE_LE_SUPPORT_FEATURE";
    AdvertisementType[AdvertisementType["BLE_AD_TYPE_CHAN_MAP_UPDATE"] = 40] = "BLE_AD_TYPE_CHAN_MAP_UPDATE";
    AdvertisementType[AdvertisementType["BLE_AD_MANUFACTURER_SPECIFIC_TYPE"] = 255] = "BLE_AD_MANUFACTURER_SPECIFIC_TYPE";
})(AdvertisementType || (AdvertisementType = {}));
let BLEObject = BLEObject_1 = class BLEObject extends RFTransmitterObject_1.RFTransmitterObject {
    constructor(address) {
        super(address ? (address instanceof MACAddress_1.MACAddress ? address.toString() : address) : undefined);
        this.manufacturerData = new Map();
        /**
         * A list of known mac address
         */
        this.knownAddresses = [];
        /**
         * Services
         */
        this._services = new Map();
        if (address instanceof MACAddress_1.MACAddress) {
            this.address = address;
            if (!this.knownAddresses.includes(address) && address !== undefined) {
                this.knownAddresses.push(address);
            }
        }
    }
    /**
     * Get BLE sercices
     * @returns {BLEService[]} BLE services
     */
    get services() {
        return Array.from(this._services.values());
    }
    addService(service) {
        this._services.set(service.uuid.toString(), service);
        return this;
    }
    /**
     * Get service by UUID
     * @param {BLEUUID} uuid Service UUID
     * @returns {BLEService} BLE Service
     */
    getServiceByUUID(uuid) {
        return this.services.find((service) => (0, BufferUtils_1.arrayBuffersAreEqual)(service.uuid.toBuffer().buffer, uuid.toBuffer().buffer));
    }
    /**
     * Create object from advertisement data
     * @param {Uint8Array} payload Advertisement data
     * @returns {BLEObject} BLE Object
     */
    static fromAdvertisementData(payload) {
        return new BLEObject_1().parseAdvertisement(payload);
    }
    /**
     * Parse advertisement data
     * @deprecated Use [parseAdvertisement] instead
     * @param {Uint8Array} payload Advertisement data
     * @returns {BLEObject} Instance
     */
    parseScanData(payload) {
        return this.parseAdvertisement(payload);
    }
    /**
     * Parse advertisement data
     * @param {Uint8Array} payload Advertisement data
     * @returns {BLEObject} Instance
     */
    parseAdvertisement(payload) {
        if (!payload) {
            return this;
        }
        this.rawAdvertisement = payload;
        const view = new DataView(payload.buffer, 0);
        for (let i = 0; i < payload.byteLength; i++) {
            let length = view.getUint8(i++); // Data length
            if (length != 0) {
                const ad_type = view.getUint8(i++); // Data type
                length--;
                switch (ad_type) {
                    case AdvertisementType.BLE_AD_TYPE_NAME_CMPL:
                        this.displayName = new TextDecoder().decode(payload.buffer.slice(i, i + length));
                        break;
                    case AdvertisementType.BLE_AD_TYPE_TX_PWR:
                        this.txPower = view.getInt8(i);
                        break;
                    case AdvertisementType.BLE_AD_TYPE_APPEARANCE:
                        this.appearance = view.getUint16(i, false);
                        break;
                    case AdvertisementType.BLE_AD_TYPE_FLAG:
                        // TODO
                        break;
                    case AdvertisementType.BLE_AD_TYPE_16SRV_CMPL:
                    case AdvertisementType.BLE_AD_TYPE_16SRV_PART:
                        // 16-bit service UUID
                        break;
                    case AdvertisementType.BLE_AD_TYPE_32SRV_CMPL:
                    case AdvertisementType.BLE_AD_TYPE_32SRV_PART:
                        // 32-bit service UUID
                        break;
                    case AdvertisementType.BLE_AD_TYPE_128SRV_CMPL:
                    case AdvertisementType.BLE_AD_TYPE_128SRV_PART:
                        // 128-bit service UUID
                        break;
                    // See CSS Part A 1.4 Manufacturer Specific Data
                    case AdvertisementType.BLE_AD_MANUFACTURER_SPECIFIC_TYPE: {
                        // Get the manufacturer
                        const data = new Uint8Array(payload.buffer.slice(i + 2, i + 2 + length));
                        const manufacturer = view.getUint16(i, true);
                        this.parseManufacturerData(manufacturer, data);
                        break;
                    }
                    case AdvertisementType.BLE_AD_TYPE_SERVICE_DATA: {
                        const uuid = BLEUUID_1.BLEUUID.fromBuffer(new Uint8Array(payload.buffer.slice(i, i + 2)), true);
                        this.parseServiceData(uuid, new Uint8Array(payload.buffer.slice(i + 2, i + length)));
                        break;
                    }
                    case AdvertisementType.BLE_AD_TYPE_32SERVICE_DATA: {
                        const uuid = BLEUUID_1.BLEUUID.fromBuffer(new Uint8Array(payload.buffer.slice(i, i + 4)), true);
                        this.parseServiceData(uuid, new Uint8Array(payload.buffer.slice(i + 4, i + length)));
                        break;
                    }
                    case AdvertisementType.BLE_AD_TYPE_128SERVICE_DATA: {
                        const uuid = BLEUUID_1.BLEUUID.fromBuffer(new Uint8Array(payload.buffer.slice(i, i + 16)), true);
                        this.parseServiceData(uuid, new Uint8Array(payload.buffer.slice(i + 16, i + length)));
                        break;
                    }
                    default:
                        break;
                }
                i += length - 1;
            }
        }
        return this;
    }
    parseServiceData(uuid, serviceData) {
        this._services.set(uuid.toString(), new BLEService_1.BLEService(uuid, serviceData));
        return this;
    }
    parseManufacturerData(manufacturer, manufacturerData) {
        this.manufacturerData.set(manufacturer, manufacturerData);
        return this;
    }
};
exports.BLEObject = BLEObject;
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Uint8Array)
], BLEObject.prototype, "rawAdvertisement", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMapMember)(Number, Uint8Array, {}),
    tslib_1.__metadata("design:type", Map)
], BLEObject.prototype, "manufacturerData", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", MACAddress_1.MACAddress)
], BLEObject.prototype, "address", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableArrayMember)(MACAddress_1.MACAddress),
    tslib_1.__metadata("design:type", Array)
], BLEObject.prototype, "knownAddresses", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], BLEObject.prototype, "mtu", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], BLEObject.prototype, "appearance", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMapMember)(String, BLEService_1.BLEService, {
        name: 'services',
    }),
    tslib_1.__metadata("design:type", Map)
], BLEObject.prototype, "_services", void 0);
exports.BLEObject = BLEObject = BLEObject_1 = tslib_1.__decorate([
    (0, core_1.SerializableObject)(),
    tslib_1.__metadata("design:paramtypes", [Object])
], BLEObject);
//# sourceMappingURL=BLEObject.js.map